import React, { useState, useEffect } from 'react'
import uuidv4 from 'uuid/v4'

import QRCode from 'components/QRCode'

const QRCodeRegistration = () => {
  const [uuid, setUuid] = useState('')

  useEffect(() => {
    const deviceIdExist = !!window.localStorage.device_id

    const createLocalUuid = () => {
      const localUuid = uuidv4()

      window.localStorage.setItem('device_id', localUuid)
      setUuid(localUuid)
    }

    if (!deviceIdExist) {
      createLocalUuid()
    } else {
      setUuid(window.localStorage.device_id)
    }
  }, [])

  const issuer = process.env.REACT_APP_OIDC_ISSUER
  const orgName = process.env.REACT_APP_ORG

  return (
    <div className="rrrr">
      <div className="ffff">
        <QRCode
          color="black"
          data={`${issuer}/devices/register/board/${uuid}?organization_name=${orgName}`}
          styles={{ maxHeight: '35vh' }}
        />
      </div>
    </div>
  )
}

export default QRCodeRegistration
